import { v4 as uuid } from "uuid";

export const generateRegistrationCode = () => {
  const allowedCharacters = "123456789ABCDEFGHIJKLMNPQRSTUVWXYZ";
  let code = "";
  for (let i = 0; i < 7; i++) {
    const randomIndex = Math.floor(Math.random() * allowedCharacters.length);
    code += allowedCharacters[randomIndex];
  }
  return code;
};

export const generateAuthToken = () => {
  return uuid();
};
